import {dateTime} from "services/date";
import {Achievement} from "types/Achievement";

/**
 * Transform the given achievement by deserializing object properties
 *
 * @internal
 * @param achievement
 */
export default function deserializeAchievement(achievement: any): Achievement {
    achievement.created_at = dateTime(achievement.created_at)
    achievement.updated_at = dateTime(achievement.updated_at)

    return achievement;
}